import {
  Avatar,
  Flex,
  ProviderConsumer as FluentUIThemeConsumer,
  Text
} from '@fluentui/react-northstar';
import React, { useEffect, useState } from 'react';
import Markdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import { getCachedUsers } from '../../../shared/cache/PlatformUserCache';
import { getFileIcon } from '../../../shared/components/EditTicketAttachments/NewAttachmentFlow/NewAttachmentFlowContent';
import { markdownComponents } from '../../../shared/utils/constants';
import { UserPic } from '../../EditTicket/UserPic';

interface Props {
  ticket: Ticket;
  view: 'list' | 'edit';
}

export const LastConvo = ({ ticket, view = 'list' }: Props) => {
  const [user, setUser] = useState({
    Id: 0,
    FullName: '',
    Email: ''
  });
  const mystyle = {
     width: '244px',
     overflow:'hidden',
     whiteSpace:'nowrap',
     textOverflow: 'ellipsis'
  }  as React.CSSProperties;;

  const [comment, setComment] = useState('');
  const [attachment, setAttachment] = useState<any>();
  const [isAutomation, setIsAutomation] = useState(false);

  useEffect(() => {
    const comment = ticket['Comments'].filter(x=>x.IsPublic && !x.IsDeleted).slice(-1).pop();
    if(comment['Body'].includes("</tikit-img>")){
      const regexExp = "<tikit-img.*?itemid=[\"'](.+?)[\"'].*?></tikit-img>";
      const urlPattern = new RegExp(regexExp, "gi");
      const matches = comment['Body'].match(urlPattern) || [];

      if(matches.length > 0){
        let match = matches[0];
        let itemId = match.match(/itemid=[\"'](.+?)[\"']/i)[1];
        let _attachment = ticket.FileAttachments.find(x => x.ContentUrl?.includes(itemId));
        
        if(_attachment){
          setAttachment(_attachment);
          comment.Body = comment.Body.replace(match, '');
        }
      }
    }else{
      let _attachment = ticket.FileAttachments.find(x=>x.FileCommentId==comment.Id);
      if(_attachment && comment['Body']=="<tikit-comment-empty></tikit-comment-empty>"){
        setAttachment(_attachment);
        comment['Body']=_attachment.FileName;
      }
    }
    
    if (comment) {
      setComment(comment['Body']);
      // A comment with no author was written by an automation. There is no user to look up, so
      // the avatar would otherwise render empty - the activity pane shows the workflow icon for
      // these, so do the same here.
      setIsAutomation(comment.CreatedById == null);
      let createdBy = comment['CreatedBy'];
      if(!createdBy){
        getCachedUsers([comment.CreatedById]).then(users => {
          let user = users.find(u => u.Id == comment.CreatedById);
          const { Id, Email, FullName } = user ?? {};
          setUser({ Id, FullName, Email });
        });
      }else{
        const { Id, Email, FullName } = createdBy ?? {};
        setUser({ Id, FullName, Email });
      }
    }
  }, [ticket]);

  return (
    <FluentUIThemeConsumer
      render={globalTheme => (
        <>
          <div className="mt-2 mb-2">
            <Flex vAlign="start">
              <Flex.Item>
                {isAutomation
                  ? <Avatar image={`${window.__runtimeConfig.platformurl}Image/workflow.png`} size="smaller" />
                  : <UserPic id={user.Id} name={user.FullName} email={user.Email} />}
              </Flex.Item>
              <Flex.Item>
                <div className="pl-2">
                  <div>
                    <Text
                      size="small"
                      weight="bold"
                      content={(user.FullName = '')}
                    />
                  </div>
                  <div style={mystyle}>
                  {attachment && 
                    <>
                      {getFileIcon(attachment.FileExtension, attachment, globalTheme)}
                    </>
                  }
                    <Text size="small" content={<Markdown remarkPlugins={[remarkGfm, remarkBreaks]} components={markdownComponents}>{comment}</Markdown>} />
                  </div>
                </div>
              </Flex.Item>
            </Flex>
          </div>
        </>
      )}
    />
  );
};
